import uiCore = require("../../core/uicore");
import entityCache = require("../../core/entitycache");
import entityHelper = require("../../core/entityhelper");

export class JobTitleEdit implements uiCore.IDirective {

    public static ComponentDescription: uiCore.IStandardPageDescription = {
        DirectiveId: "personjobtitlesedit",
        Url: "/jobtitles/{jobTitleId:int}/edit",
        HeaderText: "Resources &raquo; Persons &raquo; Jobtitles",
        StateString: "resources.personsjobtitlesedit",
        Template: require("./jobtitles.edit.html"),
        AngularDependencies: [{ $angularInjectionId: "$mdDialog" }, { $angularInjectionId: "$state" }, { $angularInjectionId: "$stateParams" }, { $angularInjectionId: "$scope" }]
    }

    public jobtitle: Nema.Crew.Model.PersonJob;
    protected dataCache: entityCache.EntityCache;
    public $mdDialog: ng.material.IDialogService;
    private $state: ng.ui.IStateService;
    public searchTextJobTitle: string;

    constructor($mdDialog, $state, $stateParams, $scope, ..._args: any[]) {
        var self = this;
        self.$mdDialog = $mdDialog;
        self.$state = $state;
        var jobTitleId = (<JobTitleStateParams><any>$stateParams).jobTitleId;
        self.dataCache = new entityCache.EntityCache(entityCache.CommonEntityManagers.EntityManager);
        var scope = $scope;

        var dataDependencies: string[] = [
            entityCache.EntityTypeNames.Person,
            entityCache.EntityTypeNames.PersonJob,
            entityCache.EntityTypeNames.JobType,
        ];
        var entitiesPromise = self.dataCache.getEntitySetsPromise(dataDependencies);

        entitiesPromise.then(_res => {
            self.jobtitle = <any>self.dataCache.getEntity(entityCache.EntityTypeNames.PersonJob, jobTitleId);
            scope.$apply();
        });

    }


    public save() {

        var listOfChanges = [
            () => { }
        ];

        entityHelper
            .saveSequentialListOfChangesAndNavigate(
            listOfChanges,
            this.dataCache.entityManager,
            () => { this.goToDetailsPage(this.$state) },
            this.$state);
    }

    public cancel() {
        this.goToDetailsPage(this.$state);
    }

    public goToPersonPage(state: ng.ui.IStateService) {
        state.go("app.resources.persons.detail", { personId: this.jobtitle.Person.Id });
    }

    public goToDetailsPage(state: ng.ui.IStateService) {
        state.go("app.resources.personsjobtitlesdetails", { jobTitleId: this.jobtitle.Id });
    }

    public searchJobTypes(searchString: string): Nema.Crew.Model.JobType[] {
        return <any[]> this.dataCache.searchActiveByName(entityCache.EntityTypeNames.JobType, searchString);
    }
}

export class JobTitleStateParams {
    jobTitleId: number;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/jobtitles/jobtitles.edit.ts